const ANCHOR_IDS = {
	PLAYER: "bp-player",
	HEADER: "bp-header",
};

export default ANCHOR_IDS;
